/****************************************************************************************
 * File Name    : SheetPatrol.vue
 * Function     :
 * Author       : 최명호
 * Tester       :
 * Page         :
 * Target       :
 * Description  :
 * Modification Log
 * ======================================================================================
 * Ver  Date        	Author     	Modification
 * ======================================================================================
   1.0  2021.04.16  	최명호    	Create
****************************************************************************************/
<template>
    <div>
        <a-row :gutter="16">
            <a-col class="gutter-row" :span="12">
                <div class="gutter-box">
                    <PageHeader title = "공정순회 보고서 관리" />
                </div>
            </a-col>
        </a-row>
        <a-divider type = 'horizontal' />
        <a-form class="" layout = "vertical" >
            <a-card>
                <a-space align="end">
                    <a-input default-value="" v-model="filterCS">
                        <a-select slot="addonAfter" default-value="모델명" v-model="filterField">
                            <a-select-option value="모델명">모델명</a-select-option>
                            <a-select-option value="제품명">제품명</a-select-option>
                            <a-select-option value="검사결과">검사결과</a-select-option>
                            <!-- <a-select-option value="작성일자">작성일자</a-select-option>
                            <a-select-option value="작성상태">작성상태</a-select-option> -->
                        </a-select>
                    </a-input>

                    <span style="display: inline-block; margin-bottom: 5px; margin-left: 10px;">일자</span>
                    <date-picker v-model="filterDateStartCS" valueType="format" style="width:120px;"></date-picker>
                    <span style="display: inline-block; margin-bottom: 5px;">~</span>
                    <date-picker v-model="filterDateEndCS" valueType="format" style="width:120px;"></date-picker>
                    
                    <a-button type="primary" ghost="true" @click="filterCSList">검색</a-button>
                    <a-button @click="resetCSList">초기화</a-button>
                </a-space>
                <p/>
                <div style="position:relative;">
                  <img id="loading-data" class="more-btn" src="../assets/images/Loading_2.gif" style="position:absolute; top:50%; left:50%; margin-top:-30px; margin-left:-30px; width:60px; z-index:10;" />
                  <a-table :columns="columns3" size = "small" :bordered=false :data-source="data3" :pagination="pagination" :scroll="{ x: 0, y: '80vh' }" @change="handleTableChange">
                      <span slot="tags" slot-scope="tags">
                          <a-tag v-for="tag in tags" :key="tag" class="state-btn" :class="{ green: (tag === '검사완료'), navy: (tag === '승인완료') }">
                              {{ tag.toUpperCase() }}
                          </a-tag>
                      </span>
                      <span slot="name" slot-scope="text">{{ text }}</span>
                      <span slot="action" slot-scope="record">
                          <span style = 'cursor:pointer' @click="handlerToViewProductCS(record.key, 'H')"><a-icon type="eye" /> View</span>
                          <a-divider type="vertical" />
                          <span style = 'cursor:pointer' @click="handlerToDeleteProductCS(record.key, 'H')"><a-icon type="delete" /> Delete</span>
                      </span>
                  </a-table>
                </div>
            </a-card>

        </a-form>
        <a-drawer title="" placement="right" :closable="false" :visible="flagForDrawer" @close="handlerForCloseDrawer" width="100%" >
            <PatrolReportViewer :target = "target" :pop = "pop" :showSaveBtn = true :showConfirmBtn = true v-on:flagForDrawer="handlerForCloseDrawer" v-on:editPatrolCS="handlerToEditPatrolCS" />
        </a-drawer>
    </div>
</template>
<script>
import _ from "lodash";
import DatePicker from 'vue2-datepicker';
import PageHeader from "../components/PageHeader.vue";
import PatrolReportViewer from "./PatrolReportViewer.vue" ;
const columns = [
    {    title: '상태'    ,   dataIndex: 'tags' ,   key: 'tags'     ,  scopedSlots: { customRender: 'tags'        },  width : 100},
    {    title: '모델명' , dataIndex: 'model' , key: 'model' , scopedSlots: { customRender: 'model' },},
    {    title: '세부모델명' , dataIndex: 'modelDetail' , key: 'modelDetail' , scopedSlots: { customRender: 'modelDetail' },},
    {    title: '제품명' , dataIndex: 'product' , key: 'product' , scopedSlots: { customRender: 'name' },},
    {    title: 'POP' , dataIndex: 'pop' , key: 'pop' , scopedSlots: { customRender: 'pop' },},
    {    title: '라인' , dataIndex: 'line' , key: 'line' , scopedSlots: { customRender: 'name' },},
    {    title: '최종수정일',  dataIndex: 'updated', key: 'updated'  ,  scopedSlots: { customRender: 'updated'     },},
    {    title: '관리'                          ,   key: 'action'   ,  scopedSlots: { customRender: 'action'      },  width : 250},
];
const columns2 = [
    {    title: '관리'                          ,   key: 'action'   ,  scopedSlots: { customRender: 'action'      },  width : 100},	
    {    title: '상태'    ,   dataIndex: 'tags' ,   key: 'tags'     ,  scopedSlots: { customRender: 'tags'        },  width : 100},	
    {    title: '이름'    ,   dataIndex: 'name' ,   key: 'name'     ,  scopedSlots: { customRender: 'name'        },},
];
const columns3 = [
    {    title: '상태'    ,   dataIndex: 'tags' ,   key: 'tags'     ,  scopedSlots: { customRender: 'tags'        },  width : 100},
    {    title: '모델명' , dataIndex: 'model' , key: 'model' , scopedSlots: { customRender: 'model' },},
    {    title: '세부모델명' , dataIndex: 'modelDetail' , key: 'modelDetail' , scopedSlots: { customRender: 'modelDetail' },},
    {    title: '제품명' , dataIndex: 'product' , key: 'product' , scopedSlots: { customRender: 'name' },},
    {    title: 'POP' , dataIndex: 'pop' , key: 'pop' , scopedSlots: { customRender: 'name' },},
    {    title: '라인' , dataIndex: 'line' , key: 'line' , scopedSlots: { customRender: 'name' },},
    {    title: '최종수정일',  dataIndex: 'updated', key: 'updated'  ,  scopedSlots: { customRender: 'updated'     },},
    {    title: '검사결과',  dataIndex: 'checkState', key: 'checkState'  ,  scopedSlots: { customRender: 'updated'     },},
    {    title: '관리'                          ,   key: 'action'   ,  scopedSlots: { customRender: 'action'      },  width : 250},
];
const data = [
  {    key: '1',    name: 'FGCS210505-WP400-V1 보류중 20200401-15:30'   ,  tags: ['필요'],  },
  {    key: '2',    name: 'FGCS210505-WP301-V1 보류중 20200329-09:30'   ,  tags: ['필요'],  },
  {    key: '3',    name: 'PCCS210505-WP400-V1 완료 20200401-15:30'     ,  tags: ['진행'],  },
  {    key: '4',    name: 'PCCS210505-WP301-V1 완료 20200329-09:30'     ,  tags: ['완료'],  },
];
const data3 = [
  {    key: '1',    name: '정수기', model: 'WP-400',cs : 'FGCS210505-WP400-V1 ',id: '홍길동',created:'2021-01-01',updated:'2021-01-01' ,  tags: ['완료'],  },
  {    key: '2',    name: '정수기', model: 'WP-400',cs : 'FGCS210505-WP400-V1 ',id: '홍길동',created:'2021-01-01',updated:'2021-01-01' ,  tags: ['완료'],  },

];
export default {
    name: 'PatrolReport',
    components: {
        PageHeader ,
        DatePicker,
        PatrolReportViewer,
    },
    data() {
        return {
            isDataLoaded : false,
            flagForDrawer: false,
            data,
            columns,
            columns2,
            columns3,
            data3,
            data3Backup: [],	
            csArray: [],	
            dataArray: [],	
            dataArray3: [],	
            pop: null,	
            target: null,	
            filterCS : '',	
            filterField: '모델명',
            filterDateStartCS: '',
            filterDateEndCS: '',
            pagination: {
                current: 1,
                pageSize: 10,
                total: 0,
                showSizeChanger: true,
                showTotal: (total, range) => `${range[0]}-${range[1]} / ${total}개`
            }
        };
    },
    mounted() {
        this.pop = sessionStorage.getItem('patrol_pop') || '';
        
        this.isDataLoaded = true;
        this.fetchProductCSList();

        const userAgent = navigator.userAgent.toLowerCase();
        const isTablet = /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|samsungbrowser|(puffin(?!.*(IP|AP|WP))))/.test(userAgent);

        if (isTablet) {
            let x;
            let els1 = document.body.querySelectorAll('.ant-layout-header');
            for (x = 0; x < els1.length; x++) {
                els1[x].style.display = 'none';
            }
            let els2 = document.body.querySelectorAll('.ant-breadcrumb');
            for (x = 0; x < els2.length; x++) {
                els2[x].style.display = 'none';
            }
            let els3 = document.body.querySelectorAll('.ant-divider-horizontal');
            for (x = 0; x < els3.length; x++) {
                els3[x].style.display = 'none';
            }
            let els4 = document.body.querySelectorAll('.desktop-only');
            for (x = 0; x < els4.length; x++) {
                els4[x].style.display = 'none';
            }
            let els5 = document.body.querySelectorAll('.ant-layout-sider');
            for (x = 0; x < els5.length; x++) {
                els5[x].style.display = 'none';
            }
        }
    },
    methods : {
        // showDrawer() {
        //     this.flagForDrawer = true;
        // },
        // closeDrawer() {
        //     this.flagForDrawer = false;
        // },
        // editTool() {
        //     console.log("## editTool in Tools ##");
        //     this.flagForDrawer = true;
        // },
        // deleteTool() {
        //     console.log("## deleteTool in Tools  ##");
        //     this.flagForDrawer = true;
        // }
        fetchProductCSList(skipBarcodeScan, forceView, queryStr, page = 1, pageSize = 10) {
            document.getElementById('loading-data').style.display = 'block';

            this.csArray = [];
            this.dataArray = [];
            this.data = [];
            let data3 = [];
            this.data3 = [];
            
            // 기존 페이징 방식으로 복원 (서버에서 정렬 처리)
            let urlToFetchProductCSList = `${this.$store.state.nodeApiUrl}/product/cs/list_simple?size=${pageSize}&page=${page-1}&state=H,L`;
            
            // 검색 쿼리가 있는 경우 추가
            if (queryStr) {
                urlToFetchProductCSList += queryStr;
            }
            
            this.$http.get(urlToFetchProductCSList)
            .then((response) => {
                if(response.status === 200 && response.data.code === 'success') {
                    // 서버에서 이미 정렬된 데이터 사용
                    const pageData = response.data.data.content;
                    
                    // 페이지네이션 정보 업데이트
                    this.pagination.total = response.data.data.totalElements;
                    this.pagination.current = page;
                    this.pagination.pageSize = pageSize;
                    
                    // 기존 구조에 맞게 데이터 설정 (빈 배열로 초기화)
                    this.dataArray = [];
                    
                    this.dataArray3 = pageData;

                    _.forEach(this.dataArray, function(item) {
                        _.forEach(item.listProductCSInpection, function(item2) {
                            if (item2.listProductCSInpectionStandard.length === 1 && item2.listProductCSInpectionStandard[0].min === '') {
                                for (var i = 0; i < 14; i++) {
                                    item2.listProductCSInpectionStandard.push(JSON.parse(JSON.stringify(item2.listProductCSInpectionStandard[0])));
                                }
                            } else if (item2.listProductCSInpectionStandard.length === 1) {
                                let min = item2.listProductCSInpectionStandard[0].min.split('||'),
                                    max = item2.listProductCSInpectionStandard[0].max.split('||'),
                                    name = item2.listProductCSInpectionStandard[0].name.split('||'),
                                    result = item2.listProductCSInpectionStandard[0].result.split('||'),
                                    obj = JSON.parse(JSON.stringify(item2.listProductCSInpectionStandard[0]));
                                for (var j = 0; j < 15; j++) {
                                    obj.min = min[j];
                                    obj.max = max[j];
                                    obj.name = name[j];
                                    obj.result = result[j];
                                    item2.listProductCSInpectionStandard[j] = JSON.parse(JSON.stringify(obj));
                                }
                            }
                        })
                    });

                    _.forEach(this.dataArray3, function(item) {
                        _.forEach(item.listProductCSInpection, function(item2) {
                            if (item2.listProductCSInpectionStandard.length === 1 && item2.listProductCSInpectionStandard[0].min === '') {
                                for (var i = 0; i < 14; i++) {
                                    item2.listProductCSInpectionStandard.push(JSON.parse(JSON.stringify(item2.listProductCSInpectionStandard[0])));
                                }
                            } else if (item2.listProductCSInpectionStandard.length === 1) {
                                let min = item2.listProductCSInpectionStandard[0].min.split('||'),
                                    max = item2.listProductCSInpectionStandard[0].max.split('||'),
                                    name = item2.listProductCSInpectionStandard[0].name.split('||'),
                                    result = item2.listProductCSInpectionStandard[0].result.split('||'),
                                    obj = JSON.parse(JSON.stringify(item2.listProductCSInpectionStandard[0]));
                                for (var j = 0; j < 15; j++) {
                                    obj.min = min[j];
                                    obj.max = max[j];
                                    obj.name = name[j];
                                    obj.result = result[j];
                                    item2.listProductCSInpectionStandard[j] = JSON.parse(JSON.stringify(obj));
                                }
                            }
                        })
                    });
                }
                for(let x = 0; x < this.dataArray.length ; x ++) {
                    let tags = ['검사중'];

                    // TO DO - 서버에서 수정한 후 이 코드 삭제 - updated 가 9 시간이 작게 나와서 프론트엔드에서 수정
                    let updatedObj = new Date((new Date(this.dataArray[x].updated)).getTime() + 9 * 60 * 60 * 1000);
                    let year = updatedObj.getFullYear();
                    let month = updatedObj.getMonth() + 1;
                    if (month < 10) {
                        month = '0' + month;
                    }
                    let date = updatedObj.getDate();
                    if (date < 10) {
                        date = '0' + date;
                    }
                    let hour = updatedObj.getHours();
                    if (hour < 10) {
                        hour = '0' + hour;
                    }
                    let minute = updatedObj.getMinutes();
                    if (minute < 10) {
                        minute = '0' + minute;
                    }
                    let second = updatedObj.getSeconds();
                    if (second < 10) {
                        second = '0' + second;
                    }

                    this.data.push({
                        key : x,
                        name : this.dataArray[x].name,
                        pop : this.dataArray[x].clsProduct.pop,
                        tags : tags,
                        // updated : this.dataArray[x].updated,
                        updated : year + '-' + month + '-' + date + ' ' + hour + ':' + minute + ':' + second,
                        model : this.dataArray[x].clsProduct.productModel,
                        modelDetail : this.dataArray[x].clsProduct.productModelDetail,
                        product : this.dataArray[x].clsProduct.productName,
                    });
                }

                // 정렬은 이미 fetchProductCSList에서 처리됨

                for(let x = 0; x < this.dataArray3.length ; x ++) {
                    // TO DO - 서버에서 수정한 후 이 코드 삭제 - updated 가 9 시간이 작게 나와서 프론트엔드에서 수정
                    let updatedObj = new Date((new Date(this.dataArray3[x].updated)).getTime() + 0 * 60 * 60 * 1000);
                    let year = updatedObj.getFullYear();
                    let month = updatedObj.getMonth() + 1;
                    if (month < 10) {
                        month = '0' + month;
                    }
                    let date = updatedObj.getDate();
                    if (date < 10) {
                        date = '0' + date;
                    }
                    let hour = updatedObj.getHours();
                    if (hour < 10) {
                        hour = '0' + hour;
                    }
                    let minute = updatedObj.getMinutes();
                    if (minute < 10) {
                        minute = '0' + minute;
                    }
                    let second = updatedObj.getSeconds();
                    if (second < 10) {
                        second = '0' + second;
                    }

                    let checkState = 'OK';
                    // _.forEach(this.dataArray3[x].listProductCSInpection, function(item) {
                    //     if (item.listProductCSInpectionStandard[0].min === 'NG') {
                    //         checkState = 'NG';
                    //     }
                    // });
                    if (this.dataArray3[x].csTime === 'NG') {
                        checkState = 'NG';
                    }

                    data3.push({
                        key : x,
                        name : this.dataArray3[x].name,
                        pop : this.dataArray3[x].clsProduct.productPop,
                        tags : (this.dataArray3[x].state === 'H' ? ['검사완료'] : ['승인완료']),
                        // updated : this.dataArray3[x].updated,
                        updated : year + '-' + month + '-' + date + ' ' + hour + ':' + minute + ':' + second,
                        model : this.dataArray3[x].clsProduct.productModel,
                        modelDetail : this.dataArray3[x].clsProduct.productModelDetail,
                        product : this.dataArray3[x].clsProduct.productName,
                        line : this.dataArray3[x].line,
                        checkState: checkState
                    });
                }
                this.data3 = data3;
                this.data3Backup = JSON.parse(JSON.stringify(this.data3));
                this.flagSpinner = false;

                if (skipBarcodeScan && forceView) {   // 바코드 스캔 또는 직접 입력 후 체크시트가 생성된 후의 조회인 경우, 수정, 삭제인 경우
                    this.target = this.dataArray[0];  // 방금 생성하였으므로 맨 처음 체크시트 조회 - 기존에는 맨 끝을 찾았으나 this.dataArray 정렬 순서 변경으로 맨 처음을 찾음
                    this.flagForDrawer = true;
                } else {
                    // 바코드 스캔한 경우
                    if (this.pop) {
                        let popMatch = false;
                        let matchedCS = null;
                        _.forEach(this.csArray, (item) => {
                            if (item.clsProduct.productPop == this.pop && item.state === 'F') {   // CS에서 바코드 스캔된 pop 에 해당하는 것이 있는지 확인. 여러개 있어도 가장 최근 것 하나를 선택
                                popMatch = true;
                                matchedCS = item;
                                return false;
                            }
                        });

                        // 바코드 매칭이 된 경우
                        if (popMatch) {
                            if (confirm(this.pop + ' 공정순회 체크시트를 작성하시겠습니까?')) {
                                // matchedCS 를 복사해서 valid 값을 C 로 하여 체크시트 생성 후 열기
                                this.handlerToCreateCSForPatrol(matchedCS);
                            } else {
                                this.pop = '';
                                sessionStorage.removeItem('patrol_pop');
                                location.reload();
                            }
                        } else {
                            this.$message.error('인식된 바코드의 제품이 등록되어 있지 않습니다.');
                        }
                    }
                }

                document.getElementById('loading-data').style.display = 'none';
            }).catch(error => {
              console.log(error);
              this.flagSpinner = false;

              document.getElementById('loading-data').style.display = 'none';
            });
        },
        handlerToConfirmProductCS(dataOffset) {
            if (confirm('완료처리하시겠습니까?')) {
                this.data3.push({
                    key: this.dataArray[dataOffset].x,
                    name: this.dataArray[dataOffset].clsProduct.productName,
                    model: this.dataArray[dataOffset].clsProduct.productModel,
                    cs : this.dataArray[dataOffset].name,
                    id: '',
                    created: this.dataArray[dataOffset].created,
                    updated: this.dataArray[dataOffset].updated,
                    tags: ['완료']
                });

                this.data.splice(dataOffset, 1);
            }
        },
        handlerToViewProductCS(dataOffset, state) {
            this.dataOffset = dataOffset;
            let target;
            if (state === 'G') {
                target = this.dataArray[dataOffset];
            } else if (state === 'H') {
                target = this.dataArray3[dataOffset];
            }

            let urlToFetchProductCSList = this.$store.state.nodeApiUrl + "/product/cs/get_patrol_cs_item?seq=" + target.productCsSeq;
                this.$http.get(urlToFetchProductCSList)
                .then((response) => {
                    if(response.status === 200 && response.data.code === 'success') {
                        let item = response.data.data.content[0];
                        this.target = item;

                        _.forEach(item.listProductCSInpection, function(item2) {
                            if (item2.listProductCSInpectionStandard.length === 1 && item2.listProductCSInpectionStandard[0].min === '') {
                                for (var i = 0; i < 14; i++) {
                                    item2.listProductCSInpectionStandard.push(JSON.parse(JSON.stringify(item2.listProductCSInpectionStandard[0])));
                                }
                            } else if (item2.listProductCSInpectionStandard.length === 1) {
                                let min = item2.listProductCSInpectionStandard[0].min && item2.listProductCSInpectionStandard[0].min.split('||') || '',
                                    max = item2.listProductCSInpectionStandard[0].max && item2.listProductCSInpectionStandard[0].max.split('||') || '',
                                    name = item2.listProductCSInpectionStandard[0].name && item2.listProductCSInpectionStandard[0].name.split('||') || '',
                                    result = item2.listProductCSInpectionStandard[0].result && item2.listProductCSInpectionStandard[0].result.split('||') || '',
                                    ngTitle = item2.listProductCSInpectionStandard[0].ngTitle && item2.listProductCSInpectionStandard[0].ngTitle.split('||') || '',
                                    ngContent = item2.listProductCSInpectionStandard[0].ngContent && item2.listProductCSInpectionStandard[0].ngContent.split('||') || '',
                                    obj = JSON.parse(JSON.stringify(item2.listProductCSInpectionStandard[0]));
                                for (var j = 0; j < 15; j++) {
                                    obj.min = min[j];
                                    obj.max = max[j];
                                    obj.name = name[j];
                                    obj.result = result[j];
                                    obj.ngTitle = ngTitle[j] ? ngTitle[j].slice(0, 30) : '';  // 최대 30글자까지 표시
                                    obj.ngContent = ngContent[j];
                                    item2.listProductCSInpectionStandard[j] = JSON.parse(JSON.stringify(obj));console.log(ngTitle[j])
                                }
                            }
                        })

                        // TO DO - 서버에서 수정한 후 이 코드 삭제 - updated 가 9 시간이 작게 나와서 프론트엔드에서 수정
                        let updatedObj = new Date((new Date(this.target.updated)).getTime() + 0 * 60 * 60 * 1000);
                        let year = updatedObj.getFullYear();
                        let month = updatedObj.getMonth() + 1;
                        if (month < 10) {
                            month = '0' + month;
                        }
                        let date = updatedObj.getDate();
                        if (date < 10) {
                            date = '0' + date;
                        }
                        let hour = updatedObj.getHours();
                        if (hour < 10) {
                            hour = '0' + hour;
                        }
                        let minute = updatedObj.getMinutes();
                        if (minute < 10) {
                            minute = '0' + minute;
                        }
                        let second = updatedObj.getSeconds();
                        if (second < 10) {
                            second = '0' + second;
                        }
                        this.target.updated = year + '-' + month + '-' + date + ' ' + hour + ':' + minute + ':' + second;

                        this.flagForDrawer = true;
                    }
                });
        },
        handlerToEditPatrolCS(listItem, state) {
            let generatedObjectToPersist = {
                productCsSeq: listItem.productCsSeq,
                productSeq: listItem.clsProduct.productSeq,
                productCSName: listItem.name,
                productCSInspections: [],
                productCSTimes: [],
                state: state,
                pop: listItem.pop,
                csTime: listItem.csTime,
                line: listItem.line,
                manager: listItem.manager,
                approver: (state === 'L' ? sessionStorage.getItem('user_name') : ''),
            };

            _.forEach(listItem.listProductCSInpection, (item) => {
                let min = [],
                    max = [],
                    name = [],
                    result = [];

                _.forEach(item.listProductCSInpectionStandard, function(item2) {
                    min.push(item2.min || '');
                    max.push(item2.max || '');
                    name.push(item2.name || '');
                    result.push(item2.result || '');
                });

                min = min.join('||');
                max = max.join('||');
                name = name.join('||');
                result = result.join('||');

                let obj = {
                    index: '' + item.inspectionIndex,
                    offset: '' + item.inspectionOffset,
                    inspection: item.inspectionName,
                    inspectionTarget: item.inspectionTarget || '',
                    standard: {
                        min: min,
                        max: max,
                        name: name,
                        result: result
                    },
                    imageSeq: item.inspectionImageSeq,
                    image2Seq: item.inspectionImage2Seq,
                    description: item.inspectionDescription
                };

                generatedObjectToPersist.productCSInspections.push(obj);
            });

            _.forEach(listItem.listProductCSTime, (item) => {
                let obj = {
                    start: item.timeStart,
                    terms: item.timeTerms
                };

                generatedObjectToPersist.productCSTimes.push(obj);
            });


            let urlForProduct = this.$store.state.hostInService + '/product/cs/edit';
            this.$http.put(urlForProduct,generatedObjectToPersist)
            .then((response) => {
                if (response.status === 200 && response.data.code === 'success') {
                    this.$message.success('저장되었습니다');
                    
                    // 현재 페이지를 유지하면서 목록의 상태만 업데이트
                    this.updateItemStateInCurrentList();
                    
                    // 레이어 닫기
                    this.flagForDrawer = false;
                }  else {
                    this.$message.error('저장되지 않았습니다(1).');
                }
            })
            .catch(error => {
                console.error(error);
                this.$message.error('저장되지 않았습니다(2).');
            });
        },
        
        updateItemStateInCurrentList() {
            // 상태 변경 후 전체 데이터 재정렬이 필요하므로 새로 데이터를 가져옴
            // 현재 페이지는 유지하면서 올바른 정렬된 데이터를 표시
            this.refreshCurrentPageData();
        },
        
        refreshCurrentPageData() {
            // 현재 검색 조건을 유지하면서 현재 페이지 데이터 다시 가져오기
            let queryStr = '';
            
            // 현재 적용된 필터 조건들 재구성
            if (this.filterCS) {
                if (this.filterField === '모델명') {
                    queryStr += '&product_model=' + encodeURIComponent(this.filterCS);
                } else if (this.filterField === '제품명') {
                    queryStr += '&product_name=' + encodeURIComponent(this.filterCS);
                } else if (this.filterField === '검사결과') {
                    queryStr += '&check_state=' + encodeURIComponent(this.filterCS.toUpperCase());
                }
            }
            
            // 날짜 필터
            if (this.filterDateStartCS) {
                queryStr += '&start_date=' + this.filterDateStartCS;
            }
            if (this.filterDateEndCS) {
                queryStr += '&end_date=' + this.filterDateEndCS + ' 23:59:59';
            }
            
            // 현재 페이지와 페이지 사이즈 유지하면서 데이터 갱신
            this.fetchProductCSList(false, false, queryStr, this.pagination.current, this.pagination.pageSize);
        },
        handlerForCloseDrawer() {
            this.flagForDrawer = false;
        },
        handlerToDeleteProductCS(dataOffset, state) {
            if (state === 'G') {
                this.target = this.dataArray[dataOffset];
            } else if (state === 'H') {
                this.target = this.dataArray3[dataOffset];
            }

            if (confirm('삭제하시겠습니까?')) {
                let urlForProduct = this.$store.state.hostInService + '/product/cs/delete';
                let listItem = this.target;
                let generatedObjectToPersist = {
                    productCsSeq: listItem.productCsSeq
                };
                this.$http.put(urlForProduct,generatedObjectToPersist)
                    .then((response) => {
                        if (response.status === 200 && response.data.code === 'success') {
                            this.$message.success('삭제되었습니다');
                            
                            // 현재 페이지와 검색 조건을 유지하면서 목록 갱신
                            this.refreshCurrentPageData();
                        }  else {
                            this.$message.error('삭제되지 않았습니다(1).');
                        }
                    })
                    .catch(error => {
                        console.error(error);
                        this.$message.error('삭제되지 않았습니다(2).');
                    });
            }
        },
        handlerToCreateCSForPatrolPop() {
            if (!this.pop) {
                this.$message.error('POP를 입력해주세요');
                return;
            }
            
            let pop = this.pop;
            if (pop) {
                sessionStorage.setItem('patrol_pop', pop);
                location.reload();
            } else {
                this.$message.error('인식된 POP의 제품이 등록되어 있지 않습니다.');
            }
        },
        handlerToCreateCSForPatrol(listItem) {

            let generatedObjectToPersist = {
                productSeq: listItem.clsProduct.productSeq,
                productCSName: 'PATROLCS-' + listItem.name,
                productCSInspections: [],
                productCSTimes: [],
                state: 'G',
                pop: this.pop,
                csTime: ''
            };

            _.forEach(listItem.listProductCSInpection, (item) => {
                let obj = {
                    index: '' + item.inspectionIndex,
                    offset: '' + item.inspectionOffset,
                    inspection: item.inspectionName,
                    inspectionTarget: item.inspectionTarget || '',
                    standard: {
                        min: item.listProductCSInpectionStandard.length && item.listProductCSInpectionStandard[0].min || '',
                        max: item.listProductCSInpectionStandard.length && item.listProductCSInpectionStandard[0].max || '',
                        name: item.listProductCSInpectionStandard.length && item.listProductCSInpectionStandard[0].name || '',
                        result: item.listProductCSInpectionStandard.length && item.listProductCSInpectionStandard[0].result || ''
                    },
                    imageSeq: item.inspectionImageSeq,
                    image2Seq: 0,
                    description: item.inspectionDescription
                };

                generatedObjectToPersist.productCSInspections.push(obj);
            });

            _.forEach(listItem.listProductCSTime, (item) => {
                let obj = {
                    start: item.timeStart,
                    terms: item.timeTerms
                };

                generatedObjectToPersist.productCSTimes.push(obj);
            });


            let urlForProduct = this.$store.state.hostInService + '/product/cs/add';
            this.$http.post(urlForProduct,generatedObjectToPersist)
            .then((response) => {
                if (response.status === 200 && response.data.code === 'success') {
                    this.$message.success('생성되었습니다');
                    this.fetchProductCSList(true, true);
                    this.pop = '';
                    sessionStorage.removeItem('patrol_pop');
                }  else {
                    this.$message.error('생성되지 않았습니다(1).');
                }
            })
            .catch(error => {
                console.error(error);
                this.$message.error('생성되지 않았습니다(2).');
            });
        },
      filterCSList() {
        let queryStr = '';
        
        // 모델명
        if (this.filterField === '모델명') {
          queryStr += '&product_model=' + this.filterCS;
        }
        // 제품명
        else if (this.filterField === '제품명') {
          queryStr += '&product_name=' + this.filterCS;
        }
        // 검사결과
        else if (this.filterField === '검사결과') {
          queryStr += '&check_state=' + this.filterCS.toUpperCase();
        }

        // 시작일
        if (this.filterDateStartCS) {
          queryStr += '&start_date=' + this.filterDateStartCS;
        }
        // 종료일
        if (this.filterDateEndCS) {
          queryStr += '&end_date=' + this.filterDateEndCS + ' 23:59:59';
        }

        // 페이지를 1로 리셋하고 검색 실행
        this.pagination.current = 1;
        this.fetchProductCSList(true, false, queryStr, 1, this.pagination.pageSize);
      },
      
      resetCSList() {
        this.filterCS = '';
        this.filterField = '모델명';
        this.filterDateStartCS = '';
        this.filterDateEndCS = '';

        // 페이지를 1로 리셋하고 검색 초기화
        this.pagination.current = 1;
        this.fetchProductCSList(true, false, '', 1, this.pagination.pageSize);
      },
      
      handleTableChange(pagination) {
        // 페이지 변경 시 현재 검색 조건 유지
        let queryStr = '';
        
        // 모델명
        if (this.filterField === '모델명') {
          queryStr += '&product_model=' + this.filterCS;
        }
        // 제품명
        else if (this.filterField === '제품명') {
          queryStr += '&product_name=' + this.filterCS;
        }
        // 검사결과
        else if (this.filterField === '검사결과') {
          queryStr += '&check_state=' + this.filterCS.toUpperCase();
        }

        // 시작일
        if (this.filterDateStartCS) {
          queryStr += '&start_date=' + this.filterDateStartCS;
        }
        // 종료일
        if (this.filterDateEndCS) {
          queryStr += '&end_date=' + this.filterDateEndCS + ' 23:59:59';
        }

        this.fetchProductCSList(true, false, queryStr, pagination.current, pagination.pageSize);
      }
    }
}
</script>
<style scoped>
</style>